exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-vacancy-img[data-v-4f7d6dc1] {\n  height: 200px;\n  border-radius: 12px;\n  overflow: hidden;\n  margin: 8px 0;\n  padding: 0;\n}\n.card-vacancy-img img[data-v-4f7d6dc1] {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n  border-radius: 12px;\n  display: block;\n}\n", ""]);

// exports
